import { NgModule } from '@angular/core';
import { MojoPrivilegesModule } from 'mojo-privileges';

import { SharedModule } from '@shared';
import { AttachmentsListModule } from '@shared/attachments-list/attachments-list.module';

import { CandidateAttachmentsConfig } from './candidate-attachments.abstract.config';
import { candidateAttachmentsConfig } from './candidate-attachments.config';
import { AttachmentsContainerComponent } from './containers';

const containers = [AttachmentsContainerComponent];

@NgModule({
  imports: [SharedModule, MojoPrivilegesModule, AttachmentsListModule],
  declarations: [...containers],
  exports: [...containers],
  providers: [
    {
      provide: CandidateAttachmentsConfig,
      useValue: candidateAttachmentsConfig,
    },
  ],
})
export class CandidateAttachmentsModule {}
